// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"03260dcd","340":"8304e5f1","984":"cd12c0c6"}[chunkId] + ".chunk.js";
};